import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'

export const UserProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  width: 100vw;

  .tabs-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    .user-settings-tabs {
      display: flex;
      flex-direction: row;
      gap: 20px;
      padding: 0 18px;

      a {
        text-decoration: none;
      }

      ${mq('max', '768px')} {
        overflow-x: scroll;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .user-profile-container {
    width: 100%;
    gap: 20px;
    max-width: 1440px;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    padding: 0 88px;
    flex-wrap: wrap;

    ${mq('max', '960px')} {
      padding: 0 18px;
    }

    .profile-content {
      display: flex;
      gap: 20px;

      ${mq('max', '960px')} {
        flex-direction: column;
      }

      .profile-left {
        flex: 1;
        gap: 20px;
        display: flex;
        flex-direction: column;
      }

      .profile-right {
        flex: 1;
      }
    }
  }

  .user-appointments-container {
    margin-top: 5rem;
    width: 100%;
    /* height: 100vh; */
    max-width: 1440px;
    padding: 0 88px;
    gap: 20px;
    display: flex;
    flex-wrap: wrap;

    ${mq('max', '910px')} {
      flex-direction: column;
      height: max-content;
      padding: 0 18px;
    }
  }

  .user-invite-container {
    margin-top: 5rem;
    width: 100%;
    height: 100vh;
    max-width: 1440px;
    padding: 0 88px;
    gap: 20px;
    display: flex;
    flex-wrap: wrap;

    ${mq('max', '910px')} {
      flex-direction: column;
      height: max-content;
      padding: 0 18px;
    }
  }

  .user-membership-container {
    margin-top: 5rem;
    width: 100%;
    height: 100vh;
    max-width: 1440px;
    padding: 0 88px;
    gap: 20px;
    display: flex;
    flex-wrap: wrap;

    ${mq('max', '910px')} {
      flex-direction: column;
      height: max-content;
      padding: 0 18px;
    }
  }

  .user-credits-container {
    margin-top: 5rem;
    width: 100%;
    height: 100vh;
    max-width: 1440px;
    padding: 0 88px;
    gap: 20px;
    display: flex;
    flex-wrap: wrap;

    ${mq('max', '910px')} {
      flex-direction: column;
      height: max-content;
      padding: 0 18px;
    }

  }

  .user-details-container {
    flex: 1;
    height: max-content;
    padding: 40px;
    background-color: ${gsColors.khaki};
    display: flex;
    flex-direction: column;

    .user-details-content {
      display: flex;
      padding: 24px 0;
      .left-container {
        flex: 1;
        .user-details-info {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
      }

      .right-container {
        display: flex;
        align-items: flex-end;
      }
    }


    .user-details-footer {
      margin-top: 30px;
      display: flex;
      gap: 30px;
    }

    ${mq('max', '960px')} {
      height: 400px;
      width: 100%;
      border-right: none;
      border-bottom: 0.5px solid #e5e5e5;
      justify-content: center;
    }
  }

  .user-payments-container {
    flex: 1;
    height: max-content;
    padding: 40px;
    background-color: ${gsColors.khaki};
    display: flex;
    flex-direction: column;

    section {
      margin: 0;
    }

    .user-default-payment {
      display: flex;
    }

    ${mq('max', '960px')} {
      width: 100%;
      border-left: none;
    }
  }

  .user-membership-container-old {
    width: 100vw;
    max-width: 1440px;
    margin-top: 5rem;
    height: 100%;

    .user-membership-inner {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      width: 100%;

      ${mq('max', '960px')} {
        flex-direction: column;
        flex-wrap: nowrap;
      }

      .membership {
        width: 50%;
        height: 50%;
        padding: 1rem;
        min-height: 350px;

        position: relative;
        border-bottom: 0.5px solid #e5e5e5;
        border-right: 0.5px solid #e5e5e5;
        flex-wrap: no-wrap;
        display: flex;
        justify-content: center;
        align-items: center;

        ${mq('max', '960px')} {
          width: 100%;
          border: none;
          border-bottom: 0.5px solid #e5e5e5;
        }

        .membership-title {
          position: absolute;
          top: 1rem;
        }

        div {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          p:nth-of-type(1) {
            margin-bottom: 1rem;
          }
        }
      }

      .membership-credits {
        width: 50%;
        height: 50%;
        padding: 1rem;

        border-bottom: 0.5px solid #e5e5e5;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        min-height: 350px;

        ${mq('max', '960px')} {
          width: 100%;
          border: none;
          border-bottom: 0.5px solid #e5e5e5;
        }

        .membership-credits-title {
          position: absolute;
          top: 1rem;
          background-color: ${gsColors.white};
        }

        div {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          max-height: 350px;
          overflow-y: scroll;
          width: 100%;
          padding: 2rem 0;
        }
      }

      .package-and-gift-credits {
        width: 50%;
        height: 50%;
        padding: 1rem;
        border-right: 0.5px solid #e5e5e5;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-height: 350px;

        ${mq('max', '960px')} {
          width: 100%;
          border: none;
          border-bottom: 0.5px solid #e5e5e5;
        }

        .package-credits-title {
          position: absolute;
          top: 1rem;
        }
      }

      .redeem-gift {
        width: 50%;
        height: 50%;
        padding: 1rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 350px;

        ${mq('max', '960px')} {
          width: 100%;
        }

        .gift-code-title {
          position: absolute;
          top: 1rem;
        }

        .gift-card-input {
          display: flex;
          flex-direction: column;
          align-items: center;

          ${mq('max', '768px')} {
            width: 100%;
            max-width: 100% !important;
          }


          div {
            display: flex;
            flex-direction: row;
            justify-content: center;

            ${mq('max', '768px')} {
              max-width: 100%;
            }

            button {
              min-width: 0px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 1rem 2rem;
              margin-left: 1rem;
            }
          }

          p {
            text-align: center;
          }
        }
      }
    }
  }

  .user-address-container {
    flex: 1;
    height: max-content;
    padding: 40px;
    background-color: ${gsColors.khaki};
    display: flex;
    flex-direction: column;

    .address-title {
      margin-bottom: 2rem;

      ${mq('max', '960px')} {
        margin-top: 1rem;
      }
    }

    & > div {
      display: flex;
      flex-direction: column;
      gap: 50px;

      button {
        ${mq('max', '960px')} {
          width: 100%;
        }
      }

      .user-address {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        /* ${mq('max', '1250px')} { */
        /*   flex-direction: column; */
        /* } */
        .left-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 12px;

          .out-of-zone {
            color: ${gsColors.errorRed};
            font-size: 14px;
          }
        }

        .right-container {
          display: flex;
          gap: 33px;
          align-items: flex-end;
        }

      }
    }

  }

  .user-promo-container {
    width: 50%;
    height: 500px;
    border-left: 0.5px solid #e5e5e5;
    border-top: 0.5px solid #e5e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .user-promo-input-container {
      display: flex;
      margin: 2rem 0;

      .user-promo-input {
        font-family: Brown;
        margin: 0 0.5rem;
        border-top: none;
        border-left: none;
        border-right: none;

        ::placeholder {
          color: e5e5e5;
        }
      }
    }

    ${mq('max', '960px')} {
      width: 100%;
      border-left: none;
      border-bottom: 1px solid #e5e5e5;
    }
  }
`
export const ProfileModalContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 40px 40px;

  .profile-inputs {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .profile-inputs input {
    font-size: 16px;
    font-family: Euclid;
  }
`
export const EditAddressModalContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 3rem 3rem 3rem;
  overflow-y: scroll;

  ${mq('max', '450px')} {
    padding: 0 1rem 1rem 1rem;
  }

  .auto-complete {
    margin-bottom: 2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;

    svg {
      transform: translate(1px, 23px);
      font-size: 1.3rem;
    }

    input {
      border: none;
      border-bottom: 0.5px solid ${gsColors.paleSlate};
      font-family: Brown;
      line-height: 1.7rem;
      width: 100%;
      transition: all 0.5s ease;
      padding-left: 1.5rem;
      &::placeholder {
        color: ${gsColors.paleSlate};
      }

      &:focus {
        outline: none;
        border-bottom: 1px solid ${gsColors.black};
      }
    }
  }

  .location-type {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    .location-type-buttons {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.5rem;
      gap: 8px;

      button {
        all: unset;
        height: 2.5rem;
        width: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${gsColors.white};
        border: 1px solid ${gsColors.lightTangerine};
        color: ${gsColors.black};
        transition: all 0.5s ease;

        ${mq('max', '600px')} {
          margin-top: 0.5rem;
        }

        &:hover {
          cursor: pointer;
        }

        &:focus {
          border: 1px solid ${gsColors.sunsetOrange};
        }

        &.selected {
          border: 1px solid ${gsColors.sunsetOrange};
          transition: all 0.5s ease;
        }
      }
    }
  }

  .location-unit {
    width: 100%;
  }

  .pet-select {
    width: 100%;
    margin-top: 20px;

    div {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.5rem;
      gap: 8px;

      button {
        all: unset;
        height: 2.5rem;
        width: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${gsColors.white};
        border: 1px solid ${gsColors.lightTangerine};
        color: ${gsColors.black};
        transition: all 0.5s ease;

        ${mq('max', '600px')} {
          margin-top: 0.5rem;
        }

        &:hover {
          cursor: pointer;
        }

        &:focus {
          border: 1px solid ${gsColors.sunsetOrange};
        }

        &.selected {
          border: 1px solid ${gsColors.sunsetOrange};
          transition: all 0.5s ease;
        }
      }
    }
  }

  .additional-info {
    width: 100%;
    margin-top: 1.5rem;

    textarea {
      resize: none;
      margin-bottom: 0.5rem;
      width: 100%;
      padding: 16px;
      height: 100px;
      font-family: Brown;
      min-height: 110px;
      border: 0.5px solid ${gsColors.paleSlate};
      transition: all 0.5s ease;
      line-height: 1.3rem;

      &:focus {
        outline: none;
        border: 1px solid ${gsColors.black};
      }
    }
  }

  .save-address-container {
    width: 100%;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    h4 {
      margin: 0;
    }
  }

  .valet-warning {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const UserMembershipContainer = styled.div`
  flex: 1;

  .content {
    background-color: ${gsColors.khaki};
    padding: 40px;
    margin-top: 34px;

    .membership-renewal-times {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .membership-renewal-time {
        display: flex;
        gap: 5px;
      }
    }

    .membership-cancel {
      button {
        text-align: left;
        min-height: unset;
      }
    }

    .membership-actions {
      margin-top: 34px;
    }
  }

`

export const UserMembershipCreditsContainer = styled.div`
  flex: 1;
  .credits-container {
    margin-top: 34px;
    padding: 40px;
    background-color: ${gsColors.khaki};

    .discount-credits {
      padding-top: 12px;
      margin-top: 12px;
      border-top: 1px solid ${gsColors.meredithGrey};
    }

    .credit-row {
      display: flex;
      justify-content: space-between;

    }
  }
`

export const UserCreditsContainer = styled.div`
  flex: 1;

  .content {
    margin-top: 34px;
    padding: 40px;
    background-color: ${gsColors.khaki};
    .no-user-credits-container {
      ${mq('max', '545px')} {
        button {
          width: 100%;
        }
      }
    }

    .credits-container {
      .credits-list {
        margin-top: 24px;
        & > *:not(:last-child) {
          border-bottom: 1px solid #D9D9D9;
        }

      }
    }
  }
`

export const UserCreditRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;

  * {
    font-weight: 600;
  }
`

export const RedeemCreditCodeWrapper = styled.div`
  flex: 1;
  .redeem-content {
    margin-top: 34px;
    padding: 40px;
    background-color: ${gsColors.khaki};

    /* override some styles from <GiftInput />  */
    & > div {
      & > div {
        display: flex;
        gap: 28px;

        ${mq('max', '545px')} {
          flex-direction: column;

          button {
            width: 100%;
          }
        }

        & > div {
          label {
            z-index: 0;
          }
        }
      }
    }

  }
`

export const InviteFriendsContainer = styled.div`
  flex: 1;
  .content {
    margin-top: 34px;
    padding: 40px;
    background-color: ${gsColors.khaki};

    .invite-url-container {
      margin-top: 16px;
      background-color: #fff;
      padding: 30px;
      display: flex;
      gap: 28px;

      ${mq('max', '545px')} {
        flex-direction: column;

        button {
          width: 100%;
        }
      }

      & > div {
        label {
          z-index: 0;
        }
      }
    }


  }
`

export const ReferralListWrapper = styled.div`
  flex: 1;
  .content {
    margin-top: 34px;
    padding: 40px;
    background-color: ${gsColors.khaki};

    .referral-list {
      & > *:is(:first-child) {
          padding: 0 0 12px 0;
      }

      & > *:not(:first-child) {
          padding: 12px 0;
      }

      & > *:not(:last-child) {
        border-bottom: 1px solid #D9D9D9;
      }
    }
  }
`

export const ReferralItemWrapper = styled.div`
  /* padding: 12px 0; */
  display: flex;
  justify-content: space-between;
  gap: 30px;
  .referrer-info {
  }

  .referrer-reward {
    width: max-content;
  }

`

export const DeleteAccountContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.5rem;

  p {
    max-width: 60%;
    text-align: center;
    margin-bottom: 1rem;

    ${mq('max', '450px')} {
      max-width: 80%;
    }
  }

  a {
    color: ${gsColors.grape};
  }

  div {
    display: flex;

    button {
      margin: 0 0.5rem;

      ${mq('max', '450px')} {
        // padding: 14px 5px 12px;
        min-width: 100px;
      }
    }
  }
`

export const AppointmentListContainer = styled.div`
  width: 100%;
  .appointment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    ${mq('max', '990px')} {
      flex-direction: column;
    }
  }
`

export const AppointmentCardContainer = styled.div`
  flex-basis: 50%;
  border: 1px solid ${gsColors.lightTangerine};
  padding: 35px;
`

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;

  .page {
    height: 3rem;
    width: 3rem;
    border: .5px solid ${gsColors.sunsetOrange};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${gsColors.white};
    color: ${gsColors.sunsetOrange};
    font-size: 1rem;
    font-family: Brown;
    padding: 10px;

    ${mq('max', '768px')} {
      height: 2.5rem;
      width: 2.5rem;
      font-size: .8rem;
    }

    &:hover {
      cursor: pointer;
    }

    &:disabled {
      opacity: .5;

      &:hover {
        cursor: auto;
      }

      &.elipse {
        opacity: 1;
      }
    }

    &.selected {
      background-color: ${gsColors.sunsetOrange};
      color: ${gsColors.white};
    }

  }
`

export const NoUpcomingAppointmentsContainer = styled.div`
  background-color: ${gsColors.khaki};
  width: calc(50% - 20px);
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  ${mq('max', '990px')} {
      width: 100%;
  }
`
